export class ActiveFixedExitEntity {
     
    id: number;
    identification: string;
    name: string;
    area: string;
    position: string;
    equipment: string;
    serial: string;
    serialEquipment: string;
    creationDate: Date;
    userId: number;
    personExit: string;
    associatedSerial: string;
    observation: string;

    constructor () {}
}